import responseService from "../../services/responseService";

const setDefaultState = () => {
  return {
    responses: [],
    finalPayload: {
      //Ex 1
      tellUsAboutYou: {
        postalCode: "",
        transportationModesAndServices: [],
        agencies: [],
        interestGroup: [],
        transportationServiceOrFrieghtProvider: [],
        govEmpOrOffical: [],
        otherStakeholderTypes: []
      },

      coordinatesWithType: [],

      //Tell Us You Needs
      YourNeedsComment: "",

      //Exercise 2 pins, general comments
      EX2: [],
      transportationCommentFields: {
        roadways: "",
        safety: "",
        regionalMobility: "",
        publicTransportation: "",
        activeTransportation: ""
      },

      //Exercise 2 "Current state of transportation system"
      currentStateOfTransportationSystem: {
        existingTransportationSystem: "",
        typesOfModes: [],
        typesOfTripPurposes: [],
        typesOfUsers: []
      },

      // Exercise 5 pins
      EX5: [],

      //Transportation Priorities
      ImproveSafety: 1,
      ImproveSecurity: 1,
      ProtectEnvironment: 1,
      ReduceCongestion: 1,
      PromoteEfficiency: 1,
      EconomicGoals: 1,
      LandGoals: 1,
      IncreaseConnection: 1,
      ImproveAccess: 1,
      ConnectTravel: 1,
      ConserveEnergy: 1,
      ImproveQOL: 1,
      ModalOptions: 1,
      PreserveROW: 1,

      //Exercise 4, Map 5
      RouteGrowth: "",
      RouteGrowthAreas: [],

      //Exercise 4, Map 4
      TransitNeeds: "",
      TransitNeedsAreas: [],

      //Exercise 4, Map 3
      AccurateCongestionMap: "",
      FutureArea: [],
      NewMexicoCongestion: "",
      WestValleyCongestion: "",
      NorthEastCongestion: "",
      CentralCongestion: "",
      CentralEastCongestion: "",
      MissionValleyCongestion: "",
      FarEastCongestion: "",

      //Exercise 4, Map 2
      EmploymentGrowth: "",
      EmploymentGrowthArea: [],
      NewMexicoEmployment: "",
      WestValleyEmployment: "",
      NorthEastEmployment: "",
      CentralEmployment: "",
      CentralEastEmployment: "",
      MissionValleyEmployment: "",
      FarEastEmployment: "",
      EmploymentChange: "",

      //Exercise 4, Map 1
      PopulationGrowth: "",
      PopulationGrowthArea: [],
      NewMexicoPopulation: "",
      WestValleyPopulation: "",
      NorthEastPopulation: "",
      CentralPopulation: "",
      CentralEastPopulation: "",
      MissionValleyPopulation: "",
      FarEastPopulation: "",
      PopulationChange: "",

      //Exercise 5
      OtherNeeds: "",
      OtherNeedsArea: [],
      RegionWideNeeds: [],
      NewMexicoNeeds: [],
      WestValleyNeeds: [],
      NorthEastNeeds: [],
      CentralNeeds: [],
      CentralEastNeeds: [],
      MissionValleyNeeds: [],
      FarEastNeeds: []
    }
  };
};

const state = setDefaultState();

const getters = {
  finalPayload: state => {
    return state.finalPayload;
  }
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  setCoordinatesWithType({ commit }, coordinatesWithType) {
    commit("SET_COORDINATES_WITH_TYPE", coordinatesWithType);
  },
  addTransporationPriority({ commit }, transportationPriority) {
    commit("ADD_TRANSPORTATION_PRIORITY", transportationPriority);
  },
  addExcercise4Response({ commit }, congestionResponse) {
    commit("ADD_EXERCISE_4_PRIORITY", congestionResponse);
  },
  addNeedsComment({ commit }, needsComment) {
    commit("ADD_NEEDS_COMMENT", needsComment);
  },
  updateMapPointTexts({ commit }, payload) {
    commit("UPDATE_MAP_POINT_TEXT", payload);
  },
  setTransportationCommentField({ commit }, comment) {
    commit("SET_TRANSPORTATION_COMMENT_FIELD", comment);
  },
  setEx1({ commit }, value) {
    commit("SET_ABOUT_YOU", value);
  },
  setEx2({ commit }, value) {
    commit("SET_CURRENT_STATE", value);
  },
  setMapConcerningPoints({ commit }, payload) {
    commit("SET_MAP_CONCERNING_POINTS", payload);
  },
  deletePointFromMap({ commit }, payload) {
    commit("DELETE_POINT_FROM_MAP", payload);
  },
  addResponse({ commit }, response) {
    return responseService.postResponses(response).then(() => {
      commit("ADD_RESPONSE", response);
    });
  }
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, setDefaultState());
  },
  SET_COORDINATES_WITH_TYPE(state, coordinatesWithType) {
    state.finalPayload.coordinatesWithType = coordinatesWithType;
  },
  ADD_EXERCISE_4_PRIORITY(state, transportationPriority) {
    state.finalPayload = {
      ...state.finalPayload,
      ...transportationPriority
    };
  },
  ADD_TRANSPORTATION_PRIORITY(state, transportationPriority) {
    state.finalPayload = {
      ...state.finalPayload,
      ...transportationPriority
    };
  },
  ADD_NEEDS_COMMENT(state, needsComment) {
    state.finalPayload.YourNeedsComment = needsComment;
  },
  UPDATE_MAP_POINT_TEXT(state, payload) {
    state.finalPayload[payload.exercise].find(
      p => p.uid === payload.uid
    ).pointComment = payload.pointComment;
  },
  SET_TRANSPORTATION_COMMENT_FIELD(state, comment) {
    state.finalPayload.transportationCommentFields[comment.field] =
      comment.text;
  },
  SET_ABOUT_YOU(state, value) {
    state.finalPayload.tellUsAboutYou[value.field] = value.text;
  },
  SET_CURRENT_STATE(state, value) {
    state.finalPayload.currentStateOfTransportationSystem[value.field] =
      value.text;
  },
  SET_MAP_CONCERNING_POINTS(state, payload) {
    state.finalPayload[payload.exercise] = payload.points;
  },
  DELETE_POINT_FROM_MAP(state, payload) {
    state.finalPayload[payload.exercise] = state.finalPayload[
      payload.exercise
    ].filter(p => p.uid !== payload.uid);
  },
  ADD_RESPONSE(state, response) {
    state.responses.push(response);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
